module.exports = __webpack_public_path__ + "static/media/side_5.324d63e4.png";